import { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Switch } from "../../components/ui/switch";
import { ShieldCheck, Save } from "lucide-react";

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then(({ data }) => setS(data)); }, []);
  if (!s) return <AdminLayout title="Settings"><div className="text-muted-foreground">Loading…</div></AdminLayout>;

  const save = async () => {
    try {
      await api.put("/admin/settings", { retention_months: Number(s.retention_months), retention_months_future: Number(s.retention_months_future), can_sponsor: !!s.can_sponsor });
      toast.success("Settings saved");
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <AdminLayout title="Settings & GDPR">
      <div className="max-w-2xl space-y-6">
        <div className="bg-white rounded-lg border border-[#E4C675]/50 shadow-sm p-6">
          <h3 className="font-heading font-semibold text-[#101820] flex items-center gap-2 mb-4"><ShieldCheck className="h-4 w-4 text-[#C79A3B]" /> Data Retention (GDPR)</h3>
          <p className="text-sm text-muted-foreground mb-4">Configurable retention periods. These are configurable business settings, not legal requirements.</p>
          <div className="grid sm:grid-cols-2 gap-5">
            <div><Label>Retention after process (months)</Label><Input data-testid="retention-months-input" type="number" value={s.retention_months} onChange={(e) => setS({ ...s, retention_months: e.target.value })} className="mt-1.5" /></div>
            <div><Label>Future-talent retention (months)</Label><Input data-testid="retention-future-input" type="number" value={s.retention_months_future} onChange={(e) => setS({ ...s, retention_months_future: e.target.value })} className="mt-1.5" /></div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-[#E4C675]/50 shadow-sm p-6">
          <h3 className="font-heading font-semibold text-[#101820] mb-4">Vacancy Sponsorship Policy</h3>
          <div className="flex items-center justify-between">
            <div><Label>Can this vacancy sponsor work permits?</Label><p className="text-xs text-muted-foreground mt-1">When off, sponsorship-required candidates are flagged for review — never auto-rejected.</p></div>
            <Switch data-testid="can-sponsor-switch" checked={!!s.can_sponsor} onCheckedChange={(v) => setS({ ...s, can_sponsor: v })} />
          </div>
        </div>
        <div className="bg-[#101820] rounded-lg p-6 text-[#FAF6EE]">
          <h3 className="font-heading font-semibold text-[#C79A3B] mb-2">AI Hiring Safeguards</h3>
          <ul className="text-sm text-[#FAF6EE]/75 space-y-1 list-disc list-inside">
            <li>Match scores are decision-support only — humans make final decisions.</li>
            <li>Protected characteristics (age, gender, ethnicity, nationality, religion, etc.) are never scored.</li>
            <li>Every score criterion includes visible evidence and can be overridden with a written reason.</li>
          </ul>
        </div>
        <Button data-testid="save-settings-button" onClick={save} className="bg-[#C79A3B] text-[#101820] font-semibold rounded-full"><Save className="h-4 w-4 mr-1" /> Save settings</Button>
      </div>
    </AdminLayout>
  );
}
